import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BuilderConfirmationsService {

  private baseURL = environment.baseUrl;

  constructor(private http: HttpClient) {}

  // One run date's dashboard sessions (ET); all=true includes manual/test sessions.
  getAudit(date: string, all: boolean): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/builderConfirmations/audit', {
      params: { date: date, all: all ? 'true' : 'false' }
    });
  }
}
